var simplemaps_worldmap_mapdata={
  main_settings: {
   //General settings
    width: "responsive", //'700' or 'responsive'
    background_color: "#FFFFFF",
    background_transparent: "yes",
    popups: "detect",
    
    //State defaults
    state_description: "State description",
    state_color: "#527677",
    state_hover_color: "#0e5457",
    state_url: "javascript:alert('Send users to a url (like http://simplemaps.com). Or, activate a javascript function upon click.');",
    border_size: "1",
    border_color: "#FFFFFF",
    all_states_inactive: "no",
    all_states_zoomable: "yes",
    location_description: "",
    location_color: "#FF1570",
    location_opacity: 0.8,
    location_hover_opacity: 1,
    location_url: "https://simplemaps.com",
    location_size: "30",
    location_type: "marker",
    location_border_color: "#FFFFFF",
    location_border: 2,
    location_hover_border: 2.5,
    all_locations_inactive: "no",
    all_locations_hidden: "no",
    
    //Label defaults
    label_color: "#b5b5b5",
    label_hover_color: "#ffffff",
    label_size: 22,
    label_font: "Kollektif",
    hide_labels: "no",
    hide_eastern_labels: false,
    manual_zoom: "no",
    back_image: "no",
    arrow_box: "no",
    navigation_size: "40",
    navigation_color: "#f7f7f7",
    navigation_border_color: "#636363",
    initial_back: "no",
    initial_zoom: -1,
    initial_zoom_solo: "no",
    region_opacity: 1,
    region_hover_opacity: 0.6,
    region_cascade_all: "yes",
    zoom_out_incrementally: "yes",
    zoom_percentage: 0.99,
    zoom_time: 0.5,
    
    //Popup settings
    popup_color: "white",
    popup_opacity: 0.9,
    popup_shadow: 1,
    popup_corners: 5,
    popup_font: "12px/1.5 Verdana, Arial, Helvetica, sans-serif",
    popup_nocss: "no",
    
    //Advanced settings
    div: "map",
    auto_load: "yes",
    rotate: "0",
    url_new_tab: "yes",
    images_directory: "default",
    import_labels: "no",
    fade_time: 0.1,
    link_text: "View Website",
    state_image_url: "",
    state_image_position: "",
    location_image_url: "",
    border_hover_color: ""
  },
  state_specific: {
    AE: {
      name: "United Arab Emirates",
      inactive: "no",
      hover_color: "#FF914D",
      color: "#26445A"
    },
    AF: {
      name: "Afghanistan"
    },
    AL: {
      name: "Albania"
    },
    AM: {
      name: "Armenia"
    },
    AO: {
      name: "Angola"
    },
    AR: {
      name: "Argentina"
    },
    AT: {
      name: "Austria",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    AU: {
      name: "Australia"
    },
    AZ: {
      name: "Azerbaidjan"
    },
    BA: {
      name: "Bosnia-Herzegovina"
    },
    BD: {
      name: "Bangladesh"
    },
    BE: {
      name: "Belgium",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    BF: {
      name: "Burkina Faso"
    },
    BG: {
      name: "Bulgaria"
    },
    BH: {
      name: "Bahrain",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    BI: {
      name: "Burundi"
    },
    BJ: {
      name: "Benin"
    },
    BN: {
      name: "Brunei Darussalam"
    },
    BO: {
      name: "Bolivia",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    BR: {
      name: "Brazil"
    },
    BS: {
      name: "Bahamas"
    },
    BT: {
      name: "Bhutan"
    },
    BW: {
      name: "Botswana"
    },
    BY: {
      name: "Belarus"
    },
    BZ: {
      name: "Belize",
      hover_color: "#FF914D",
      color: "#26445A"
    },
    CA: {
      name: "Canada",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    CD: {
      name: "Congo"
    },
    CF: {
      name: "Central African Republic"
    },
    CG: {
      name: "Congo"
    },
    CH: {
      name: "Switzerland"
    },
    CI: {
      name: "Ivory Coast"
    },
    CL: {
      name: "Chile",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    CM: {
      name: "Cameroon"
    },
    CN: {
      name: "China"
    },
    CO: {
      name: "Colombia",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    CR: {
      name: "Costa Rica",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    CU: {
      name: "Cuba"
    },
    CV: {
      name: "Cape Verde"
    },
    CY: {
      name: "Cyprus"
    },
    CZ: {
      name: "Czech Republic"
    },
    DE: {
      name: "Germany",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    DJ: {
      name: "Djibouti"
    },
    DK: {
      name: "Denmark"
    },
    DO: {
      name: "Dominican Republic",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    DZ: {
      name: "Algeria"
    },
    EC: {
      name: "Ecuador",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    EE: {
      name: "Estonia"
    },
    EG: {
      name: "Egypt",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    EH: {
      name: "Western Sahara"
    },
    ER: {
      name: "Eritrea"
    },
    ES: {
      name: "Spain"
    },
    ET: {
      name: "Ethiopia"
    },
    FI: {
      name: "Finland"
    },
    FJ: {
      name: "Fiji"
    },
    FK: {
      name: "Falkland Islands"
    },
    FR: {
      name: "France",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    GA: {
      name: "Gabon"
    },
    GB: {
      name: "Great Britain",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    GE: {
      name: "Georgia",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    GF: {
      name: "French Guyana"
    },
    GH: {
      name: "Ghana"
    },
    GL: {
      name: "Greenland"
    },
    GM: {
      name: "Gambia"
    },
    GN: {
      name: "Guinea"
    },
    GQ: {
      name: "Equatorial Guinea"
    },
    GR: {
      name: "Greece",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    GS: {
      name: "S. Georgia & S. Sandwich Isls."
    },
    GT: {
      name: "Guatemala"
    },
    GW: {
      name: "Guinea Bissau"
    },
    GY: {
      name: "Guyana",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    HN: {
      name: "Honduras",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    HR: {
      name: "Croatia"
    },
    HT: {
      name: "Haiti",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    HU: {
      name: "Hungary"
    },
    IC: {
      name: "Canary Islands"
    },
    ID: {
      name: "Indonesia",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    IE: {
      name: "Ireland"
    },
    IL: {
      name: "Israel",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    IN: {
      name: "India",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    IQ: {
      name: "Iraq"
    },
    IR: {
      name: "Iran"
    },
    IS: {
      name: "Iceland"
    },
    IT: {
      name: "Italy"
    },
    JM: {
      name: "Jamaica"
    },
    JO: {
      name: "Jordan"
    },
    JP: {
      name: "Japan"
    },
    KE: {
      name: "Kenya",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    KG: {
      name: "Kyrgyzstan"
    },
    KH: {
      name: "Cambodia"
    },
    KP: {
      name: "North Korea"
    },
    KR: {
      name: "South Korea",
      hover_color: "#FF914D",
      color: "#26445A"
    },
    KW: {
      name: "Kuwait"
    },
    KZ: {
      name: "Kazakhstan"
    },
    LA: {
      name: "Laos"
    },
    LK: {
      name: "Sri Lanka"
    },
    LR: {
      name: "Liberia"
    },
    LS: {
      name: "Lesotho"
    },
    LT: {
      name: "Lithuania",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    LU: {
      name: "Luxembourg"
    },
    LV: {
      name: "Latvia"
    },
    LY: {
      name: "Libya"
    },
    MA: {
      name: "Morocco"
    },
    MD: {
      name: "Moldavia"
    },
    ME: {
      name: "Montenegro"
    },
    MG: {
      name: "Madagascar"
    },
    MK: {
      name: "Macedonia",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    ML: {
      name: "Mali"
    },
    MM: {
      name: "Myanmar"
    },
    MN: {
      name: "Mongolia"
    },
    MR: {
      name: "Mauritania"
    },
    MW: {
      name: "Malawi"
    },
    MX: {
      name: "Mexico",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    MY: {
      name: "Malaysia"
    },
    MZ: {
      name: "Mozambique"
    },
    NA: {
      name: "Namibia"
    },
    NC: {
      name: "New Caledonia (French)"
    },
    NE: {
      name: "Niger"
    },
    NG: {
      name: "Nigeria",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    NI: {
      name: "Nicaragua",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    NL: {
      name: "Netherlands",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    NO: {
      name: "Norway"
    },
    NP: {
      name: "Nepal"
    },
    NZ: {
      name: "New Zealand",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    OM: {
      name: "Oman"
    },
    PA: {
      name: "Panama",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    PE: {
      name: "Peru",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    PG: {
      name: "Papua New Guinea"
    },
    PH: {
      name: "Philippines",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    PK: {
      name: "Pakistan",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    PL: {
      name: "Poland"
    },
    PR: {
      name: "Puerto Rico"
    },
    PS: {
      name: "Palestine"
    },
    PT: {
      name: "Portugal"
    },
    PY: {
      name: "Paraguay"
    },
    QA: {
      name: "Qatar"
    },
    RO: {
      name: "Romania"
    },
    RS: {
      name: "Serbia"
    },
    RU: {
      name: "Russia",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    RW: {
      name: "Rwanda"
    },
    SA: {
      name: "Saudi Arabia"
    },
    SB: {
      name: "Solomon Islands"
    },
    SD: {
      name: "Sudan"
    },
    SE: {
      name: "Sweden"
    },
    SI: {
      name: "Slovenia"
    },
    SK: {
      name: "Slovak Republic"
    },
    SL: {
      name: "Sierra Leone"
    },
    SN: {
      name: "Senegal"
    },
    SO: {
      name: "Somalia"
    },
    SR: {
      name: "Suriname"
    },
    SS: {
      name: "South Sudan"
    },
    SV: {
      name: "El Salvador",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    SY: {
      name: "Syria"
    },
    SZ: {
      name: "Swaziland"
    },
    TD: {
      name: "Chad"
    },
    TG: {
      name: "Togo"
    },
    TH: {
      name: "Thailand",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    TJ: {
      name: "Tadjikistan"
    },
    TL: {
      name: "East Timor"
    },
    TM: {
      name: "Turkmenistan"
    },
    TN: {
      name: "Tunisia",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    TR: {
      name: "Turkey"
    },
    TT: {
      name: "Trinidad and Tobago"
    },
    TW: {
      name: "Taiwan"
    },
    TZ: {
      name: "Tanzania"
    },
    UA: {
      name: "Ukraine"
    },
    UG: {
      name: "Uganda"
    },
    US: {
      name: "United States",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    UY: {
      name: "Uruguay",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    UZ: {
      name: "Uzbekistan"
    },
    VE: {
      name: "Venezuela",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    VN: {
      name: "Vietnam",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    VU: {
      name: "Vanuatu"
    },
    YE: {
      name: "Yemen"
    },
    ZA: {
      name: "South Africa",
      color: "#26445A",
      hover_color: "#FF914D"
    },
    ZM: {
      name: "Zambia"
    },
    ZW: {
      name: "Zimbabwe"
    }
  },
  locations: {
    "0": {
      lat: 30.856,
      lng: -96.571,
      name: "3385 S San Gabriel St, Hearne, TX 77859",
      color: "#ff0000",
      description: "Genemco Inc."
    },
    "1": {
      lat: 24.469,
      lng: 54.372,
      name: "Abu Dhabi",
      color: "#FF914D",
      description: "United Arab Emirates"
    },
    "2": {
      lat: 48.203,
      lng: 16.368,
      name: "Vienna",
      color: "#FF914D",
      description: "Austria"
    },
    "3": {
      lat: 50.844,
      lng: 4.356,
      name: "Brussels",
      color: "#FF914D",
      description: "Belguim"
    },
    "4": {
      lat: 26.23,
      lng: 50.576,
      name: "Manama",
      color: "#FF914D",
      description: "Bahrain"
    },
    "5": {
      lat: -19.039,
      lng: -65.256,
      name: "Sucre",
      color: "#FF914D",
      description: "Bolivia"
    },
    "6": {
      lat: 17.254,
      lng: -88.77,
      name: "Belmopan",
      color: "#FF914D",
      description: "Belize"
    },
    "7": {
      lat: 45.422,
      lng: -75.691,
      name: "Ottawa",
      color: "#FF914D",
      description: "Canada"
    },
    "8": {
      lat: -33.437,
      lng: -70.65,
      name: "Santiago",
      color: "#FF914D",
      description: "Chile"
    },
    "9": {
      lat: 4.615,
      lng: -74.069,
      name: "Bogota",
      color: "#FF914D",
      description: "Colombia"
    },
    "10": {
      lat: "9.7489",
      lng: "84.0907",
      name: "San Jose",
      color: "#FF914D",
      description: "Costa Rica"
    },
    "11": {
      lat: 52.516,
      lng: 13.377,
      name: "Berlin",
      color: "#FF914D",
      description: "Germany"
    },
    "12": {
      lat: 18.472,
      lng: -69.891,
      name: "Santo Domingo",
      color: "#FF914D",
      description: "Dominican Republic"
    },
    "13": {
      lat: -0.206,
      lng: -78.509,
      name: "Quito",
      color: "#FF914D",
      description: "Ecuador"
    },
    "14": {
      lat: 30.044,
      lng: 31.235,
      name: "Cairo",
      color: "#FF914D",
      description: "Egypt"
    },
    "15": {
      lat: 48.857,
      lng: 2.341,
      name: "Paris",
      color: "#FF914D",
      description: "France"
    },
    "16": {
      lat: 51.506,
      lng: -0.127,
      name: "London",
      color: "#FF914D",
      description: "Great Britain"
    },
    "17": {
      lat: 41.709,
      lng: 44.796,
      name: "Tbilisi",
      color: "#FF914D",
      description: "Georgia"
    },
    "18": {
      lat: 37.976,
      lng: 23.736,
      name: "Athens",
      color: "#FF914D",
      description: "Greece"
    },
    "19": {
      lat: 6.809,
      lng: -58.161,
      name: "Georgetown",
      color: "#FF914D",
      description: "Guyana"
    },
    "20": {
      lat: 14.082,
      lng: -87.205,
      name: "Tegucigalpa",
      color: "#FF914D",
      description: "Honduras"
    },
    "21": {
      lat: 18.545,
      lng: -72.336,
      name: "Port-au-Prince",
      color: "#FF914D",
      description: "Haiti"
    },
    "22": {
      lat: -6.171,
      lng: 106.826,
      name: "Jakarta",
      color: "#FF914D",
      description: "Indonesia"
    },
    "23": {
      lat: 31.78,
      lng: 35.209,
      name: "Jerusalem",
      color: "#FF914D",
      description: "Israel"
    },
    "24": {
      lat: 28.631,
      lng: 77.217,
      name: "New Delhi",
      color: "#FF914D",
      description: "India"
    },
    "25": {
      lat: -1.284,
      lng: 36.824,
      name: "Nairobi",
      color: "#FF914D",
      description: "Kenya"
    },
    "26": {
      lat: 37.559,
      lng: 127,
      name: "Seoul",
      color: "#FF914D",
      description: "South Korea"
    },
    "27": {
      lat: 54.691,
      lng: 25.27,
      name: "Vilnius",
      color: "#FF914D",
      description: "Lithuania"
    },
    "28": {
      lat: 41.995,
      lng: 21.43,
      name: "Skopje",
      color: "#FF914D",
      description: "Macedonia"
    },
    "29": {
      lat: 19.277,
      lng: -99.139,
      name: "Mexico City",
      color: "#FF914D",
      description: "Mexico"
    },
    "30": {
      lat: 9.063,
      lng: 7.462,
      name: "Abuja",
      color: "#FF914D",
      description: "Nigeria"
    },
    "31": {
      lat: 12.117,
      lng: -86.241,
      name: "Managua",
      color: "#FF914D",
      description: "Nicaragua"
    },
    "32": {
      lat: 52.37,
      lng: 4.873,
      name: "Amsterdam",
      color: "#FF914D",
      description: "Netherlands"
    },
    "33": {
      lat: -41.29,
      lng: 174.777,
      name: "Wellington",
      color: "#FF914D",
      description: "New Zealand"
    },
    "34": {
      lat: 8.952,
      lng: -79.535,
      name: "Panama City",
      color: "#FF914D",
      description: "Panama"
    },
    "35": {
      lat: -12.056,
      lng: -77.027,
      name: "Lima",
      color: "#FF914D",
      description: "Peru"
    },
    "36": {
      lat: 14.605,
      lng: 120.986,
      name: "Manila",
      color: "#FF914D",
      description: "Philippines"
    },
    "37": {
      lat: 33.71,
      lng: 73.075,
      name: "Islamabad",
      color: "#FF914D",
      description: "Pakistan"
    },
    "38": {
      lat: 55.757,
      lng: 37.615,
      name: "Moscow",
      color: "#FF914D",
      description: "Russia"
    },
    "39": {
      lat: 13.7,
      lng: -89.207,
      name: "San Salvador",
      color: "#FF914D",
      description: "El Salvador"
    },
    "40": {
      lat: 13.753,
      lng: 100.505,
      name: "Bangkok",
      color: "#FF914D",
      description: "Thailand"
    },
    "41": {
      lat: 36.8,
      lng: 10.183,
      name: "Tunis",
      color: "#FF914D",
      description: "Tunisia"
    },
    "42": {
      lat: 38.89,
      lng: -77.032,
      name: "Washington, D.C.",
      color: "#FF914D",
      description: "United States"
    },
    "43": {
      lat: -34.874,
      lng: -56.163,
      name: "Montevideo",
      color: "#FF914D",
      description: "Uruguay"
    },
    "44": {
      lat: 10.505,
      lng: -66.918,
      name: "Caracas",
      color: "#FF914D",
      description: "Venezuela"
    },
    "45": {
      lat: 21.029,
      lng: 105.855,
      name: "Hanoi",
      color: "#FF914D",
      description: "Vietnam"
    },
    "46": {
      lat: -33.919,
      lng: 18.422,
      name: "Cape Town",
      color: "#FF914D",
      description: "South Africa"
    }
  },
  regions: {},
  labels: {},
  legend: {
    entries: []
  }
};